module.exports = __webpack_public_path__ + "img/news.a44f0e06.svg";